import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import {Asset} from '@deviceinsight/ng-ui-api-client';
import {DEVICE_ONLINE_STATUS_TRANSLATIONS} from '../../../modules/common/translations';
import {DATAPOINT_IS_ONLINE} from '../../../modules/common/consts';
import './SelectedDevice.less';
import {AssetLiveData} from '../common/useAssetSubscription';

type Props = {
	asset: Asset | null | undefined;
	liveData?: AssetLiveData;
};

const SelectedDevice = ({asset, liveData = {}}: Props) => {
	if (!asset) {
		return (
			<label>
				<Trans i18nKey="dashboard.widgets.floorplan.assetinfo.helper">
					Move over the Devices to see detail / interact
				</Trans>
			</label>
		);
	}

	const isOnline = liveData[DATAPOINT_IS_ONLINE] as boolean;
	const onlineStatusClasses = classNames('online-state', {
		online: isOnline === true,
		offline: isOnline === false,
		unknown: typeof isOnline !== 'boolean'
	});
	return (
		<div className="floorplan-selected-device">
			<div>
				<div className="selection-info">
					<label>
						<Trans i18nKey="dashboard.widgets.floorplan.assetinfo.selectedAsset">Selected device:</Trans>
					</label>
					<Link to={`/assets/${asset.id}`} data-testid="asset-link">
						{asset.name} - {asset.urn}
					</Link>
				</div>
				<div className={onlineStatusClasses} data-testid="online-state">
					<span>
						{
							DEVICE_ONLINE_STATUS_TRANSLATIONS[
								typeof isOnline === 'boolean' ? isOnline.toString() : 'unknown'
							]
						}
					</span>
				</div>
			</div>
		</div>
	);
};

export default SelectedDevice;
